import { render, staticRenderFns } from "./SMAZgbTeamMembersModify.vue?vue&type=template&id=2f52ff66"
import script from "./SMAZgbTeamMembersModify.vue?vue&type=script&lang=js"
export * from "./SMAZgbTeamMembersModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports